import { canonicalEditorImportProject, createEditorImportIdentity, hasEditorImportAdmission, useUploadStore } from "../../store/uploadStore";

// One React application session, surviving iframe/Editor remount. Each new Unity
// bridge binds its first snapshot to this session; queues always serialize afresh.
const sessionId = createEditorImportIdentity();
let revision = 0;
let previousSignature = "";

export function getEditorImportStateSnapshot() {
  const reservations = Object.values(useUploadStore.getState().items)
    .filter((item) => hasEditorImportAdmission(item) && canonicalEditorImportProject(item.originViewrGcsPath) && Number.isInteger(item.targetSpaceIndex))
    .map((item) => ({ ownerId: item.id, viewrGCSPath: canonicalEditorImportProject(item.originViewrGcsPath)!, targetSpaceIndex: item.targetSpaceIndex! }))
    .sort((a, b) => a.ownerId.localeCompare(b.ownerId));
  const signature = JSON.stringify(reservations);
  if (signature !== previousSignature) { previousSignature = signature; revision += 1; }
  return { sessionId, revision, reservations };
}

export function serializeEditorImportCommand(command: string, payload: Record<string, unknown>) {
  return JSON.stringify({ command, payload: { ...payload, editorImportState: getEditorImportStateSnapshot() } });
}

/** Legacy/raw sender queues store command text, never a durable projection. */
export function refreshEditorImportMessage(gameObject: string, method: string, value: string): string {
  if (gameObject !== "ViewRReactBridge" || method !== "ReceiveFromReact") return value;
  try {
    const parsed = JSON.parse(value);
    if (typeof parsed.command !== "string") return value;
    return serializeEditorImportCommand(parsed.command, parsed.payload ?? {});
  } catch { return value; }
}
